export default __webpack_public_path__ + "static/media/director3.70a895c2.jpeg";